module.exports = __webpack_public_path__ + "static/allyoucanmove_phone-abc8d5d1991054d82e5a0e5022aa7582.png";